export enum IntegrationType {
  CLEVERREACH = "cleverreach",
  MAILCHIMP = "mailchimp",
  NEWSLETTER_2_GO = "newsletter2go",
  RAPIDMAIL = "rapidmail",
  OMNILETTER = "simplyletter",
  BREVO = "brevo",
  KLAVIYO = "klaviyo",
  SHOPWERK = "shopwerk",
  /** @deprecated */
  GMAIL = "gmail",
  /** @deprecated */
  SMTP = "smtp"
}

export type ConnectViewComponentProps = {
  connectingType: IntegrationType | undefined;
  onStartConnecting: (type: IntegrationType) => void;
  onStopConnecting: () => void;
};

export type IntegrationSystem = {
  ConnectView: React.ComponentType<ConnectViewComponentProps>;
  SettingsView: React.ComponentType;
};

export type IntegrationInfoList = {
  id: string;
  name: string;
};
export type IntegrationInfo = {
  accountName: string;
  lists: IntegrationInfoList[];
};
